import { RunStatus } from '@/api/fleet-tracking/types';

export function isCompletedOrClosed(status: RunStatus | undefined) {
  switch (status) {
    case RunStatus.Completed:
    case RunStatus.Closed:
    case RunStatus.Cancelled:
      return true;
    default:
      return false;
  }
}
